
import { computed, defineComponent, getCurrentInstance, onMounted, onUnmounted, PropType, ref, watch } from 'vue';

import LuminaAD from '@/pages/pwa-share-new/components/lumina-ad/index.vue';

const closeIconCdnUrl = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/ai_close.png';

const AILuminaAdsPopup = defineComponent({
    components: {
        LuminaAD,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close'],
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const adsLoaded = ref(false);
        const showReconfirmDialog = ref(false);
        const index = ref(0); // 更新index触发加载新的广告
        const social_ai_ads_string = proxy?.$store?.state?.startup?.social_ai_ads;
        let social_ai_ads;
        if (social_ai_ads_string) {
            try {
                social_ai_ads = JSON.parse(social_ai_ads_string);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn('Parse app ads_time_control error: ', error);
            }
            console.log('lumina-ad', 'aichat-ads', proxy?.$store?.state?.startup, social_ai_ads);
        }

        const { lumina_ads_connt_down_time } = social_ai_ads || {};
        const ads_connt_down = Number(lumina_ads_connt_down_time) > 0 ? Number(lumina_ads_connt_down_time) : 5;
        const isCounting = ref(true);
        const totalSeconds = ref(ads_connt_down);
        const init = () => {
            isCounting.value = true;
            totalSeconds.value = 5;
        };

        const adsTips = computed(() => {
            return proxy?.$root?.$t?.('ai_ads_tips', {
                // eslint-disable-next-line no-use-before-define
                seconds: `${totalSeconds.value}`,
            });
        });

        const dialogText = ref('');
        const formatTextWithNumbers = (text: string): { text: string; isNumber: boolean }[] => {
            const parts: { text: string; isNumber: boolean }[] = [];
            const regex = /\b(\d+)\b/g;
            let match;
            let lastIndex = 0;

            let result = regex.exec(text);
            while (result !== null) {
                const start = result.index;
                const end = start + result[0].length;

                if (start > lastIndex) {
                    parts.push({ text: text.slice(lastIndex, start), isNumber: false });
                }
                parts.push({ text: result[0], isNumber: true });

                lastIndex = end;
                result = regex.exec(text);
            }

            if (lastIndex < text.length) {
                parts.push({ text: text.slice(lastIndex), isNumber: false });
            }

            return parts;
        };

        const formattedDialogText = computed(() => {
            return formatTextWithNumbers(dialogText.value);
        });

        const updateCountdown = () => {
            if (totalSeconds.value > 0) {
                totalSeconds.value -= 1;
            } else {
                isCounting.value = false;
            }
        };

        // Methods
        const showDialog = () => {
            dialogText.value = proxy?.$root?.$t?.('ai_ads_pops', {
                // eslint-disable-next-line no-use-before-define
                seconds: `${totalSeconds.value}`,
            });
            showReconfirmDialog.value = true;
        };
        const closeAds = (finished: boolean) => {
            emit('close', finished);
            showReconfirmDialog.value = false;
            index.value += 1;
        };

        const handleNaviBack = () => {
            if (!isCounting.value || totalSeconds.value === 0) {
                closeAds(!isCounting.value || totalSeconds.value === 0);
            } else {
                showDialog();
            }
        };

        const onDialogCancel = () => {
            closeAds(false);
        };

        const onDialogConfirm = () => {
            showReconfirmDialog.value = false;
        };

        // Hanlde Events
        const onLuminaAdLoadFailed = () => {
            adsLoaded.value = false;
        };

        const onLuminaAdLoaded = () => {
            adsLoaded.value = true;
        };

        // eslint-disable-next-line no-undef
        let intervalId: NodeJS.Timer;
        watch(
            () => props.show,
            newVal => {
                if (newVal) {
                    intervalId = setInterval(updateCountdown, 1000);
                    return;
                }
                init();
                clearInterval(intervalId);
            }
        );

        onMounted(() => {});
        onUnmounted(() => {});
        return {
            onLuminaAdLoadFailed,
            onLuminaAdLoaded,
            adsLoaded,
            index,
            handleNaviBack,
            closeIconCdnUrl,
            onDialogCancel,
            onDialogConfirm,
            showReconfirmDialog,
            dialogText,
            adsTips,
            formattedDialogText,
        };
    },
});

export default AILuminaAdsPopup;
